// fullstack design
export const DOMAIN_DRIVEN_DESIGN = "Domain Driven Design";
